const privateWellnessExperience = (
  <div>
    <h2>Private Wellness Experience</h2>
    <p>
      Whether you're planning a birthday, grand opening, self-care gathering,
      wellness workshop, community healing event, college-based program, or
      business wellness activation, R3 can curate a trauma-conscious experience
      for your audience. Choose from Trauma-Conscious Yoga, Breathwork,
      Meditation, or Sound Bath sessions, or combine modalities into a custom
      wellness flow that supports connection, regulation, and restoration.
      <br />
      <br />
      <strong style={{ color: "#839abf" }}>
        Duration: 60 minutes Fee:
        <br />
        ~ 4-7 participants: $225
        <br />
        ~ 8-12 participants: $375
        <br />
        ~ 12+ participants: Contact us for a personalized quote (Pricing may
        vary for Corporate Wellness events)
        <br />
        <br />
        Ready to create an unforgettable experience? Feel free to make a request
        so we can curate an experience that aligns with your needs.
      </strong>
    </p>
  </div>
);

export default privateWellnessExperience;
